import { module } from 'angular';
import { GmcApi } from './gmc-api';
import { PROJECT_CONFIG, projectConfig } from './project-config.constant';

export const CoreConstantsModule = module('app.core.constants', [])
  .constant(GmcApi.name, new GmcApi())
  .constant(PROJECT_CONFIG, projectConfig);



// WEBPACK FOOTER //
// ./app/core/constants/constants.module.ts